export const ACCESS_TOKEN = 'Access-Token'
export const USERNAME = 'USERNAME'
export const USER_ID = 'USER_ID'
export const COMPANY_ID = 'COMPANY_ID'
export const TRAVENO = 'TRAVENO'
export const OUTPERSONNUM = 'OUTPERSONNUM'
export const RESERVE = 'RESERVE'
export const OUTPERSONDATA = 'OUTPERSONDATA'
export const TRAVELLEVELDATA = 'TRAVELLEVELDATA'
export const VIOLATEDATA = 'VIOLATEDATA'
export const DOMTICKETRESERVE = 'DOMTICKETRESERVE'
export const FLIGHTVIOLATE = 'FLIGHTVIOLATE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js